import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toggleFullscreen } from '../utils/fullscreenUtils';

const HeaderLogoPanel: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="w-full md:w-64 md:min-w-64 md:max-w-64 flex items-center justify-center md:justify-between px-1">
      {/* Logo */}
      <div className="flex items-center space-x-2 ps-2 md:ps-4 pe-2 me-1">
        <button
          onClick={() => navigate('/miai')}
          className="flex items-center cursor-pointer"
          title="Live Trading Studio"
        >
          <img
            src="/images/lts_1.svg"
            alt="Live Trading Studio"
            className="h-8 md:h-9 w-auto object-contain outline-none"
          />
        </button>
      </div>
      
      {/* Fullscreen Toggle Button - Hidden on mobile */}
      <div className="hidden xl:flex items-center space-x-2">
        <button
          onClick={() => toggleFullscreen()}
          className="p-1 rounded-lg transition-all duration-200 shadow-xs border theme-bg-quaternary hover:theme-bg-quinary theme-text-secondary hover:text-[#2AB7A6] theme-border group"
          title="Toggle Fullscreen"
        >
          {/* Expand (Fullscreen) Icon */}
          <svg
            className="w-4 h-4 transition-colors duration-200"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 8V4h4M20 8V4h-4M4 16v4h4M20 16v4h-4"
              className="transition-colors duration-200 group-hover:stroke-[#2AB7A6]"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default HeaderLogoPanel;
